import { makeRequest } from "../components/utils/APIsUtils/httpsUtils";
import { BaseService } from "./BaseService";

export default class SegmentsService extends BaseService {

    static async getSegmentList() {
        const response = await makeRequest({
            method: 'GET',
            endpoint: `/api/v1/segments`,
        });

        if (response != 'ERR_NETWORK' && response?.data) return response;
        else throw new Error("Failed to fetch market segments");
    }

    static async assignSegmentId(partyId, country) {
        const response = await makeRequest({
            method: 'PUT',
            endpoint: `/api/v1/users/segment`,
            body: {
                partyId,
                country
            }
        });

        if (response != 'ERR_NETWORK' && response?.data) return response;
        else throw new Error("Failed to assign the market segment");
    }
}
